import React, { useCallback } from 'react';
import { ButtonGroup, Button, Popover, OverlayTrigger, Stack } from '../../ui-kit';
import { IconArrowLeft, IconArrowRight } from '../../ui-kit/icons';
import PeriodSelector from '../../../utils/forms/PeriodSelector';
import { groupSchedulePath } from '../../../utils/paths';
import SaveButton from '../../general/SaveButton';
import moment from 'moment';

const DutyPlannerToolbar = ({
  startTime,
  endTime,
  groupId,
  changeViewingPeriod, // function that alters the time frame
  periodChange, // callback function for the the time frame changes
  syncPeriodWithDutyPlannerRedux, // auxiliary function to sync the redux store with the new time frame
  storeChanges,
  hasUnsavedChanges,
  isSaving,
  isProcessing,
  readOnly,
  getAutoSeatAllocations,
  isLoading
}) => {
  const linkToRota = groupSchedulePath(groupId, startTime, endTime);

  const calculateEndTime = useCallback(
    (newStartTime, newEndTime) => {
      if (newStartTime.format() !== moment(startTime).format()) {
        // First calculate the time difference between the new end time
        // and the old start time.
        const diff = newEndTime.clone().diff(startTime, 'seconds');
        // Add the difference to the newStartTime
        newEndTime = newStartTime.clone().add(diff, 'seconds');
      }

      periodChange({
        start_time: newStartTime.format(),
        end_time: newEndTime.format()
      });
    },
    [startTime, endTime]
  );

  const MoreInfoPopOver = (
    <Popover id="popover-basic" placement="right" positionLeft={200} positionTop={50}>
      <Popover.Header>{I18n.t('duty_planner.auto_allocate')}</Popover.Header>
      <Popover.Body>{I18n.t('duty_planner.auto_allocate_description')}</Popover.Body>
    </Popover>
  );

  return (
    <>
      <Stack direction="horizontal" gap={3} className="d-print-none align-items-start">
        <div className="d-inline-block">
          <PeriodSelector
            size={'medium'}
            startTime={startTime}
            endTime={endTime}
            onChange={periodChange}
            defaultTimeJump={24}
            calculateEndTime={calculateEndTime}
            horizontal={true}
          />
        </div>
        <Button variant="primary" onClick={syncPeriodWithDutyPlannerRedux} disabled={isLoading}>
          {I18n.t('apply')}
        </Button>
        <ButtonGroup className="ms-4">
          <Button variant="secondary" onClick={() => changeViewingPeriod(-1)} disabled={isLoading}>
            <IconArrowLeft /> {I18n.t('previous_day')}
          </Button>
          <Button variant="info" onClick={() => changeViewingPeriod('today')} disabled={isLoading}>
            {I18n.t('dates.today')}
          </Button>
          <Button variant="secondary" onClick={() => changeViewingPeriod(1)} disabled={isLoading}>
            {I18n.t('next_day')} <IconArrowRight />
          </Button>
        </ButtonGroup>
      </Stack>
      <Stack direction="horizontal" gap={3} className="d-print-none mb-2">
        {readOnly || <SaveButton onClick={storeChanges} hasUnsavedChanges={hasUnsavedChanges} isSaving={isSaving} />}{' '}
        {readOnly || (
          <Button onClick={getAutoSeatAllocations} disabled={isProcessing} variant="info">
            {I18n.t('duty_planner.auto_allocate')}{' '}
            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={MoreInfoPopOver}>
              <i className="fa fa-circle-question" />
            </OverlayTrigger>
          </Button>
        )}
        <Button className="float-right ms-auto" href={linkToRota} target="_blank">
          {I18n.t('show_schedule')}
        </Button>
      </Stack>
    </>
  );
};

export default DutyPlannerToolbar;
